import { BookingPlatform } from '$houdini';

export type WebPlatform = {
	[K in keyof typeof BookingPlatform]: K extends `WEB_${string}`
		? (typeof BookingPlatform)[K]
		: never;
}[keyof typeof BookingPlatform];

export function getPlatform(): WebPlatform {
	return isSmallDevice() === undefined && isLargeDevice() === undefined
		? BookingPlatform.WEB_DESKTOP
		: isSmallDevice()
			? BookingPlatform.WEB_MOBILE
			: isLargeDevice()
				? BookingPlatform.WEB_DESKTOP
				: BookingPlatform.WEB_TABLET;
}

export function isSmallDevice() {
	if (typeof window === 'undefined') {
		return;
	}
	return window.innerWidth <= 640; // TODO: vérifier avec l'équipe analytics et marketing
}

export function isLargeDevice() {
	if (typeof window === 'undefined') {
		return;
	}
	return window.innerWidth > 1024; // TODO: vérifier avec l'équipe analytics et marketing
}
